export default function(ngModule) {
    ngModule.factory('Coupon', function(BaseClass,$q, $http, Role) {

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function Coupon(attributes) {
            _.assign(this,attributes);

            if (this.status !== 'enabled' && this.status !== 'disabled') {
                this.status = 'enabled';
            }
        }
        Coupon.modelName = 'Coupon';


        BaseClass.apply(Coupon);

        Coupon.validates({
            name: {
                required: true
            },
            amount: {
                required: true,
                numericality: true
            },
            start_date: {
                format: {
                    regex: {
                        regex: /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{2}:\d/,
                        message: 'must be a valid date'
                    }
                }
            },
            end_date: {
                format: {
                    regex: {
                        regex: /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{2}:\d/,
                        message: 'must be a valid date'
                    }
                }
            },
            status: {
                required: true,
                inclusion: {
                    in: ['enabled', 'disabled']
                }
            },
            products: {
                minSelected: {
                    validator: function(value) {
                        if(Role.isAuthorizedAs('Admin') || Role.isAuthorizedAs('Whitelabel Admin')) {
                            return true;
                        }
                        if(!value) {
                            return false;
                        }

                        return value.length > 0;
                    },
                    message: 'select at least 1 product'
                }
            },
            type: {
                required: true,
                inclusion: {
                    in: ['fixed-discount', 'percentage-discount', 'new-price', 'cheque']
                }
            }
        });

        Coupon.configureApi('/coupon/:guid', { queryAdmin: '/coupon/:status/:company', reinstate: '/coupon/:guid/reinstate' });
        Coupon.hasMany('CouponCode', 'codes', 'guid', '/coupon/:guid/codes', 'Codes');
        Coupon.belongsToMany('Product', 'products', '/coupon/:guid/products/^guid', [
            { type: 'query' },
            { type: 'attach' },
            { type: 'detach' }
        ]);
        Coupon.prototype.toString = function() { return this.name; };

        return Coupon;
    });
}
